<script setup>
import {useBaseStore} from "~/stores/base";
import {URL_CATEGORY} from "~/utils/constants";

const router = useRouter()

/** props **/
const props = defineProps({
  product: {
    default: {},
    required: true
  }
})

const back = () => {
  router.back();
}

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
</script>

<template>
  <div class="module-breadcrumb-mobile" v-if="isMobile">
    module-breadcrumb-mobile
  </div>
  <div class="module-breadcrumb-desktop" v-else>
    <div class="back" @click="back">
      <img src="@/assets/img/icon-arrow-left-gray.svg" alt="back">
    </div>
    <span
      v-for="item in product.categoryList"
    >
      <nuxt-link
        class="category"
        :to="`${URL_CATEGORY}/${item.menuId}?title=${item.menuTitle}`"
      >
        {{ item.menuTitle }}
      </nuxt-link>
      <span class="slash">/</span>
    </span>
    <div class="name">{{ product.title }}</div>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-breadcrumb-mobile {
}

.module-breadcrumb-desktop {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  color: $color-gray-500;

  /* Text sm/Regular */
  font-family: "TWK Lausanne";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */

  .back {
    display: flex;
    margin-right: 6px;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .category {
    &:hover {
      text-decoration: underline;
    }
  }

  .slash {
    margin: 0 6px;
  }

  .name {
    color: $color-gray-800;
  }
}
</style>
